import * as React from 'react'

import { styled, spacing } from '@thg-commerce/gravity-theme'
import { SafeHtml } from '@thg-commerce/gravity-elements'

const BadgeTitle = styled(SafeHtml)<{
  removeTextDecoration?: boolean
  addPadding?: boolean
}>`
  color: ${(props) => props.theme.colors.palette.brand.base} !important;
  text-decoration: ${(props) => !props.removeTextDecoration && `underline`};
  ${(props) => props.addPadding && `padding: ${spacing(1)}`}
`

export interface ProductSpecialOfferBadgeProps {
  text: string
  showGiftsIcon?: boolean
  onClick?: (event?: React.MouseEvent) => void
  removeTextDecoration?: boolean
  addPadding?: boolean
}

export const ProductSpecialOfferBadge = (
  props: ProductSpecialOfferBadgeProps,
) => {
  return props?.onClick ? (
    <button onClick={props.onClick} data-testid="special-offer-badge-button">
      <BadgeTitle
        content={props.text}
        removeTagsAndContent={false}
        removeTextDecoration={props.removeTextDecoration}
        addPadding={props.addPadding}
      />
    </button>
  ) : (
    <div data-testid="special-offer-badge-div">
      <BadgeTitle content={props.text} removeTagsAndContent={false} />
    </div>
  )
}
